export const htmlExports = {
  popupHtml: "/popup.html",
  requestHtml: "/request.html",
  requestOnboardingHtml: "/requestOnboarding.html",
};
